import { useRoutes } from 'react-router-dom'

import GuestRoutes from './GuestRoutes'
import MainRoutes from './MainRoutes'

const Routes = () => {
  return useRoutes([MainRoutes, GuestRoutes])
}

export default Routes
